export default __webpack_public_path__ + "static/media/deposit_icon_black.4da8ef3d.svg";